<template>
  <el-form-item label="色卡" :label-width="labelWidth">
    <el-select
      v-model="selectCardId"
      placeholder="请选择色卡"
      style="width: 100%;"
      filterable
      clearable
      :disabled="disabled"
    >
      <el-option v-for="item in cards" :key="item.id" :label="item.cardName" :value="item.id"></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name:'CardSelector',
  props: {
    labelWidth: String,
    cardId: Number
  },
  data() {
    return {
      selectCardId:null,
      cards: [],
      disabled: false
    };
  },
  created: function() {
    console.log("cust selector created");
    this.selectCardId = this.cardId;
    var self = this;
    this.$axios.get("public/colorCard/query").then(function(response) {
      if (response.data.errorCode == "00000") {
        self.cards = response.data.data.list;
      } else {
        self.$message.error(response.data.errorMsg);
      }
    });
  }
};
</script>